export const labTemplateInstancesConstants = {
    GET_LAB_TEMPLATE_INSTANCES: 'GET_LAB_TEMPLATE_INSTANCES',
    GET_LAB_TEMPLATE_INSTANCES_SUCCESS: 'GET_LAB_TEMPLATE_INSTANCES_SUCCESS',
    GET_LAB_TEMPLATE_INSTANCES_ERROR: 'GET_LAB_TEMPLATE_INSTANCES_ERROR',

    SET_LAB_TEMPLATE_ACTIVE_INSTANCE: 'SET_LAB_TEMPLATE_ACTIVE_INSTANCE'
};